import React from 'react';
import {
  Box, DialogContent, DialogActions, Dialog, TextField,
} from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { Button, theme, useStyles } from './styles';

const NewEntrieEdit = (props) => {
  const {
    formEdit,
    openEdit,
    onCloseEdit,
    onChangeForm,
    onSubmitEdit,
  } = props;
  const classes = useStyles();

  return (
    <Dialog maxWidth="sm" fullWidth open={openEdit} onClose={onCloseEdit}>
      <Box
        component="form"
        onSubmit={(e) => {
          onSubmitEdit(e);
          onCloseEdit();
        }}
      >
        <DialogContent>
          <ThemeProvider theme={theme}>
            <TextField
              className={classes.inputs}
              value={formEdit.asunto || ''}
              onChange={(event) => onChangeForm(event, 'asunto')}
              required
              fullWidth
              label="Asunto"
              variant="outlined"
              multiline
              minRows={6}
            />
            <TextField
              className={classes.inputs}
              value={formEdit.cuerpo || ''}
              onChange={(event) => onChangeForm(event, 'cuerpo')}
              required
              fullWidth
              label="Cuerpo"
              variant="outlined"
              multiline
              minRows={6}
            />
          </ThemeProvider>
        </DialogContent>
        <DialogActions className={classes.cardAction}>
          <Button type="button" onClick={onCloseEdit}>Cancelar</Button>
          <Button type="submit">Aceptar</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default NewEntrieEdit;
